import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@src/index.css";
import { SnackbarProvider } from "@context/SnackBarProvider";
import { BackdropProvider } from "@context/BackdropProvider";

const theme = createTheme({
  palette: {
    primary: {
      main: "#243852",
    },
  },
});

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <QueryClientProvider client={queryClient}>
        <BackdropProvider>
          <SnackbarProvider>
            <App />
          </SnackbarProvider>
        </BackdropProvider>
      </QueryClientProvider>
    </ThemeProvider>
  </React.StrictMode>
);
